/* User types */

export const USERS_USER_TYPE_VALUE_ADMIN = "admin";
export const USERS_USER_TYPE_VALUE_CUSTOMER = "customer";
export const USERS_USER_TYPE_VALUE_GUEST = "guest";

/** key fo windows */

export const USERS_USER_DATA_WINDOW_VALUE = "userData";
